<template>
  <div class="hello">
    <p class="title">这是404页面</p>
  </div>
</template>

<script>
export default {
  name: '404',
}
</script>

<style scoped lang="less">
.title {
  color: red;
  text-align: center;
  font-size: 20px;
}
</style>
